/**
 * Country name → Flag emoji auto-mapping
 */
const COUNTRY_FLAGS = {
    'afghanistan': '🇦🇫', 'albania': '🇦🇱', 'algeria': '🇩🇿', 'argentina': '🇦🇷', 'australia': '🇦🇺',
    'austria': '🇦🇹', 'bahrain': '🇧🇭', 'bangladesh': '🇧🇩', 'belgium': '🇧🇪', 'brazil': '🇧🇷',
    'brunei': '🇧🇳', 'cambodia': '🇰🇭', 'canada': '🇨🇦', 'chile': '🇨🇱', 'china': '🇨🇳',
    'colombia': '🇨🇴', 'croatia': '🇭🇷', 'cyprus': '🇨🇾', 'czech': '🇨🇿', 'denmark': '🇩🇰',
    'egypt': '🇪🇬', 'estonia': '🇪🇪', 'finland': '🇫🇮', 'france': '🇫🇷', 'germany': '🇩🇪',
    'greece': '🇬🇷', 'hong kong': '🇭🇰', 'hungary': '🇭🇺', 'india': '🇮🇳', 'indonesia': '🇮🇩',
    'iran': '🇮🇷', 'iraq': '🇮🇶', 'ireland': '🇮🇪', 'israel': '🇮🇱', 'italy': '🇮🇹',
    'japan': '🇯🇵', 'jordan': '🇯🇴', 'kazakhstan': '🇰🇿', 'kenya': '🇰🇪', 'korea': '🇰🇷',
    'south korea': '🇰🇷', 'north korea': '🇰🇵', 'kuwait': '🇰🇼', 'laos': '🇱🇦', 'latvia': '🇱🇻',
    'lebanon': '🇱🇧', 'libya': '🇱🇾', 'lithuania': '🇱🇹', 'luxembourg': '🇱🇺', 'malaysia': '🇲🇾',
    'maldives': '🇲🇻', 'malta': '🇲🇹', 'mexico': '🇲🇽', 'mongolia': '🇲🇳', 'morocco': '🇲🇦',
    'myanmar': '🇲🇲', 'nepal': '🇳🇵', 'netherlands': '🇳🇱', 'new zealand': '🇳🇿', 'nigeria': '🇳🇬',
    'norway': '🇳🇴', 'oman': '🇴🇲', 'pakistan': '🇵🇰', 'panama': '🇵🇦', 'peru': '🇵🇪',
    'philippines': '🇵🇭', 'poland': '🇵🇱', 'portugal': '🇵🇹', 'qatar': '🇶🇦', 'romania': '🇷🇴',
    'russia': '🇷🇺', 'saudi arabia': '🇸🇦', 'singapore': '🇸🇬', 'slovakia': '🇸🇰', 'slovenia': '🇸🇮',
    'south africa': '🇿🇦', 'spain': '🇪🇸', 'sri lanka': '🇱🇰', 'sweden': '🇸🇪', 'switzerland': '🇨🇭',
    'taiwan': '🇹🇼', 'thailand': '🇹🇭', 'turkey': '🇹🇷', 'uae': '🇦🇪', 'united arab emirates': '🇦🇪',
    'uk': '🇬🇧', 'united kingdom': '🇬🇧', 'usa': '🇺🇸', 'united states': '🇺🇸', 'ukraine': '🇺🇦',
    'uzbekistan': '🇺🇿', 'vietnam': '🇻🇳', 'yemen': '🇾🇪',
};

export function getFlag(countryName) {
    if (!countryName) return '🏳';
    const key = countryName.toLowerCase().trim();
    // Exact match
    if (COUNTRY_FLAGS[key]) return COUNTRY_FLAGS[key];
    // Partial match
    for (const [name, flag] of Object.entries(COUNTRY_FLAGS)) {
        if (name.includes(key) || key.includes(name)) return flag;
    }
    return '🏳';
}
